import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.NAVIGATION]: {
		el: {
			'Home': 'Αρχική',
			'Logout': 'Αποσύνδεση',
			'Issues' : 'Εργασίες',
			'Check Lists History': 'Ιστορικό "Καλώς Έχειν"',
			'Example Report': 'Παράδειγμα Report',
			'Questionnaire': 'Ερωτηματολόγιο',
			'Questionnaire History': 'Ιστορικό Ερωτηματολογίου',
			'Planned Maintenance':'Περιοδικές Εργασίες'
		},
		en: {},
	},
	[Namespaces.FILES]: {
		el: {
			'Description': 'Περιγραφή',
			'Cancel': 'Ακύρωση',
			'Uploading': 'Μεταμόρφωση',
			'No description yet': 'Χωρίς περιγραφή',
			'Download': 'Λήψη',
			'Edit': 'Επεξεργασία',
			'Delete': 'Διαγραφή',
			'Upload File': 'Ανέβασμα Αρχείου',
			'Drag \'n\' drop some files here, or click to select files': 'Σύρετε αρχεία εδώ, ή πατήστε για να επιλέξετε.',
			'Uploaded File(s)': 'Ανεβασμένα Αρχεία',
			'Take Photo': 'Λήψη Φωτογραφίας',
		},
		en: {},
	},
	[Namespaces.CONFIRMATION]: {
		el: {
			'NO': 'ΟΧΙ',
			'YES': 'ΝΑΙ'
		},
		en: {},
	},
	[Namespaces.AXIOS_ERROR_MESSAGE]: {
		el: {
			'More': 'Περισσότερα..',
			'Less': 'Λιγότερα',
			'Unauthorized': 'Ο χρήστης δεν έχει πρόσβαση στην ιστοσελίδα.',
			'Failed to get notifications.': 'Αδυναμία φόρτωσης ειδοποιήσεων.',
			'Duplicate Entry': 'Υπάρχει ήδη αυτή η εγγραφή',
			'Not Found': 'Δεν βρέθηκε',
			errorMessage: 'Μήνυμα',
			'Message': 'Μήνυμα',
			moreMessage: '',
			'Code': 'Κωδικός',
			'Status': 'Status',
		},
		en: {
			'More': 'More..',
		}
	},
	[Namespaces.COPY_TO_CLIPBOARD]: {
		el: {
			'Copy': 'Αντιγραφή',
			'Copied': 'Αντιγράφηκε',
		},
		en: {}
	},
	[Namespaces.ALERTS]: {
		el: {
			'An error occurred!': 'Παρουσιάστηκε κάποιο σφάλμα!',
			'Details': 'Λεπτομέρειες',
			'Cancel': 'Ακύρωση',
			'Confirm': 'Επιβεβαίωση'
		},
		en: {}
	},
	[Namespaces.MUI_GRID]: {
		el: {
			'Add': 'Προσθήκη',
			'Actions': 'Ενέργειες',
			'Press Yes to confirm entry deletion.': 'Πατήστε ΝΑΙ για να επιβεβαιώσετε τη διαγραφή της εγγραφής.',
			'Delete Entry Confirmation.': 'Επιβεβαίωση Διαγραφής.',
			'no': 'Όχι',
			'yes': 'Ναι'
		},
		en: {
			'no': 'No',
			'yes': 'Yes'
		},
	},
	[Namespaces.GRID_STATE]: {
		el: {
			'Custom view': 'Προσαρμοσμένη όψη',
			'Cancel': 'Ακύρωση',
			'Create view': 'Νέα Όψη',
			'Save current view': 'Αποθήκευση όψης',
			'Custom view label': 'Ετικέτα όψης',
			'New custom view': 'Νέα προσαρμοσμένη όψη'
		},
		en: {}
	},
	[Namespaces.EDITABLE_MUI_GRID]: {
		el: {
			'Add': 'Προσθήκη',
			'Actions': 'Ενέργειες',
			'Press Yes to confirm entry deletion.': 'Πατήστε ΝΑΙ για να επιβεβαιώσετε τη διαγραφή της εγγραφής.',
			'Delete Entry Confirmation.': 'Επιβεβαίωση Διαγραφής.',
			'Confirm': 'Επιβεβαίωση',
			'Cancel': 'Ακύρωση',
			'Save': 'Αποθήκευση',
			'Edit': 'Επεξεργασία',
			'Delete': 'Διαγραφή'
		},
		en: {
			'no': 'No',
			'yes': 'Yes',
		},
	},
	[Namespaces.CONTENT_NOT_FOUND]: {
		el: {
			'Content not available or no data found for this section!': 'Το περιεχόμενο δεν είναι διαθέσιμο ή δεν βρέθηκαν δεδομένα!'
		},
		en: {}
	},
}

export default locales
